<template>
  <div>
    <TestSearchWidget />
    <RecentTestsWidget class="mt-3" />
  </div>
</template>

<script>
  import axios from 'axios'
  import TestSearchWidget from '../components/TestSearchWidget.vue'
  import RecentTestsWidget from '../components/RecentTestsWidget.vue'

  export default {
    name: 'Dashboard',
    components: {
      TestSearchWidget,
      RecentTestsWidget
    }
  }
</script>
